const styles = () => ({
  sendAgainContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "16px 0px",
    minHeight: "55px",
  },
  sendAgainButtonText: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: "#889db3",
    textTransform: "capitalize",
  },
  sendAgainButton: {
    borderRadius: "40px",
    border: "none",
    backgroundColor: "#18AA33",
    color: "#ffffff",
    padding: "10px 20px",
    transition: "all 300ms",
    "&:hover": {
      backgroundColor: "#0F6B20",
    },
  },
  sendAgainButtonDisabled: {
    border: "1px solid #f0f2f4 !important",
    padding: "6px 12px",
  },
  sendAgainButtonIcon: {
    fontSize: "16px !important",
    backgroundColor: "#ebedf1",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  appStoreImg: {
    objectFit: "cover",
  },
  title: {
    margin: "1.5rem 0rem",
  },
  formTitle: {
    fontSize: "24px",
    fontWeight: 600,
    color: "#2D2E2E",
  },
  formSubtitle: {
    fontSize: "16px",
    color: "#355273",
    margin: "4px 0px",
    "& > span": {
      fontWeight: 700,
      fontSize: "16px",
    },
  },
});

export default styles;
